<template>
  <div class="publishLazad">
      <div class="center">
          <div class="desctext">{{$t('other.a285')}}/LAZADA</div>
          <div class="hgfb">
            <span>{{$t('other.a288')}}：</span>
            <el-select size="mini" @change="getCategory()" v-model="shopId" :placeholder="$t('other.a50')">
                <el-option v-for="item in lazadashops" :key="item.sellerId" :label="item.name" :value="item.sellerId"></el-option>
            </el-select>
            <span class="tips">{{$t('other.a2881')}}</span>
          </div>
          <div>
              <span>{{$t('other.a2882')}}:</span>
          </div>
          <div class="categoryWrapper">
              <div >
                  
                  <el-scrollbar class="boxwrapper"> 
                  <div class="ingk" @click="addItem(firstItem,1)" v-for="(firstItem,index) in categorylist" :key="index">
                      <span class="name">{{firstItem.name}}</span>
                      <span class="bkng"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk" @click="addItem(firstItem,2)" v-for="(firstItem,index) in categorylistTwo" :key="index">
                      <span class="name">{{firstItem.name}}</span>
                      <span class="bkng"  v-show="firstItem.children"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk"  @click="addItem(firstItem,3)" v-for="(firstItem,index) in categorylistThree" :key="index">
                      <span class="name">{{firstItem.name}}</span>
                      <span class="bkng" v-show="firstItem.children"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk"  @click="addItem(firstItem,4)" v-for="(firstItem,index) in categorylistfour" :key="index">
                      <span class="name">{{firstItem.name}}</span>
                      <span class="bkng" v-show="firstItem.children"></span>
                  </div>
                  </el-scrollbar>
              </div>
              <div >
                  <el-scrollbar class="boxwrapper">
                  <div class="ingk"  @click="addItem(firstItem,5)" v-for="(firstItem,index) in categorylistfive" :key="index">
                      <span class="name">{{firstItem.name}}</span>
                      <span class="bkng" v-show="firstItem.children"></span>
                  </div>
                  </el-scrollbar>
              </div>
          </div>

          <div class="categoryDesc">
              <span class="categoryname">{{$t('other.a2883')}}：</span>
              <span class="categoryname" v-for="(item,index) in categoryname " :key="index">{{item}} 
                  <span v-show="item">/</span>
              </span>
              
          </div>

          <div class="footer">
              <el-button type="primary" @click="publish()">{{$t('other.a2884')}}</el-button>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../../api/moudles/lazadaorders' 
export default {
data(){
return{
    lazadashops:[],
    userId:null,
    shopId:null,
    categorylist:[],
    shopName:null,
    categorylistTwo:[],
    categorylistThree:[],
    categorylistfour:[],
    categorylistfive:[],
    categoryname:[],
    categoryId:[]
}
},
created(){
    let shops=JSON.parse(localStorage.getItem('userInfo'))
    this.userId=shops ? shops.userId : null
    this.lazadashops =shops ? shops.lazadaShops : []
},
methods:{
    publish(){

        if(!this.categoryId[0]){
            this.$message.warning(this.$t('other.a2885'))
            return
        }
        let lazadashops=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
        let params={
            shopId:this.shopId,
            shopName:this.shopName,
            categoryname:this.categoryname,
            categoryId:this.categoryId,
            country:lazadashops.find(item => item.sellerId == this.shopId).country
        }

        localStorage.setItem('addLazada',JSON.stringify(params))

        if(!this.$route.query.groupId){
            this.$router.push({
                path:'/addNewGoods',
                query:{
                    productId:this.$route.query.id,
                    type:'lazada'
                    
                }
            })

        }else{
            this.$router.push({
                path:'/addGoods',
                query:{
                    productId:this.$route.query.id,
                    groupId:this.$route.query.groupId,
                    type:'lazada'
                    
                }
            })

        }
        
        
        
    },
    addItem(item,num){
        console.log(item,num)
        if(num == 1){
            this.categorylistTwo=item.children
            this.categorylistThree=[]
            this.categorylistfour=[]
            this.$set(this.categoryname,num-1,item.name)
            this.$set(this.categoryId,num-1,item.categoryId)
        }
        if(num == 2){
            this.categorylistThree=item.children
            this.$set(this.categoryname,num-1,item.name)
            this.$set(this.categoryId,num-1,item.categoryId)
        }
        if(num == 3){
            this.categorylistfour=item.children
            this.$set(this.categoryname,num-1,item.name)
            this.$set(this.categoryId,num-1,item.categoryId)
        }

        if(num == 4){
            this.categorylistfive=item.children
            this.$set(this.categoryname,num-1,item.name)
            this.$set(this.categoryId,num-1,item.categoryId)
        }

        if(num == 5){
            this.$set(this.categoryname,num-1,item.name)
            this.$set(this.categoryId,num-1,item.categoryId)
        }

        this.categoryname.forEach((p,index) => {
            if(index > num-1){
                this.$set(this.categoryname,index,null)
                this.$set(this.categoryId,index,null)
            }
        })

        console.log('categoryname',this.categoryname)
        console.log('categoryId',this.categoryId)
    },

    

    getCategory(){
        this.shopName=this.lazadashops.find(item => item.sellerId == this.shopId).name
        api
        .getLazadaCategory({
            userId:this.userId,
            shopId:this.shopId,
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        this.categorylist=res.data
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.publishLazad{
    margin-top: $top_header_height;
    position: relative;

    .center{
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 1248px;
        // background-color: #eee;
        height: calc(100vh - 50px);

        .categoryDesc{
            background-color: #f7f8fa;
            margin-top: 20px;
            padding: 10px 0;
        }

        .categoryname{
            margin:0  15px;
        }


        .desctext{
            font-size: 20px;
            color: #757575;
            padding: 10px 0;
        }

        .categoryWrapper{
            display: flex;
            margin-top: 15px;
            width:1258px;
            overflow: hidden;
            overflow-x: scroll;

        }

        .footer{
            position: fixed;
            text-align: center;
            left: 0;
            right: 0;
            bottom: 0;
            padding:  15px 0;
            height: 40px;
            background-color: #eee;
        }

        .hgfb{
            padding: 20px 0;
            
        }

        .tips{
            color: red;
            margin-left: 20px;
        }

        .ingk{
            padding: 5px 0;
            cursor: pointer;
        }

        .ingk:hover{
            background-color: #edf7ff;
        }

        .bkng{
            float: right;
            width: 0;
            height: 0;
            border-top: 5px solid transparent;
            border-left: 5px solid #dadada;
            border-bottom: 5px solid transparent;
            position: relative;
            top: 6px;
            right: 15px;
        }

        .boxwrapper{
            width: 312px;
            height: 356px;
            overflow: hidden;
            border: 1px solid #dbdbdb;
        }

        .name{
            font-size: 12px;
            padding-left: 15px;
        }
        
    }

    /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
    }
}

</style>